<ion-app>

  @if (globalError()) {
    <div class="global-error-banner">
      <span>⚠ {{ globalError() }}</span>
    </div>
  }

  @if (auth.isLoggedIn()) {
    <div class="admin-shell">

      <!-- Overlay backdrop -->
      @if (sidebarOpen()) {
        <div class="sidebar-overlay" (click)="closeSidebar()"></div>
      }

      <!-- Sidebar drawer -->
      <aside class="sidebar" [class.open]="sidebarOpen()">
        <div class="sidebar-header">
          <div class="brand">
            <img src="assets/moreka-logo.svg" alt="Moreka" class="brand-logo">
            <p class="brand-sub">Admin Panel</p>
          </div>
          <button class="close-sidebar-btn" (click)="closeSidebar()">
            <ion-icon name="close-outline"></ion-icon>
          </button>
        </div>

        <nav class="sidebar-nav">
          @for (sec of visibleNavSections; track sec.section) {
            <p class="nav-section-label">{{ sec.section }}</p>
            @for (item of sec.items; track (item.kind === 'link' ? item.path : item.label)) {
              @if (item.kind === 'link') {
                <a class="nav-item"
                  [routerLink]="item.path"
                  routerLinkActive="active"
                  (click)="closeSidebar()">
                  <ion-icon [name]="item.icon"></ion-icon>
                  <span>{{ item.label }}</span>
                  @if (badgeFor(item.path) > 0) {
                    <span class="nav-badge">{{ badgeFor(item.path) }}</span>
                  }
                </a>
              } @else {
                <button class="nav-group-header" (click)="toggleGroup(item.label, $event)">
                  <ion-icon [name]="item.icon"></ion-icon>
                  <span>{{ item.label }}</span>
                  @if (groupHasBadge(item.children) && !expandedGroups()[item.label]) {
                    <span class="nav-group-dot"></span>
                  }
                  <ion-icon name="chevron-down-outline" class="nav-group-chevron"
                    [class.open]="expandedGroups()[item.label]"></ion-icon>
                </button>
                @if (expandedGroups()[item.label]) {
                  <div class="nav-group-children">
                    @for (child of item.children; track child.path) {
                      <a class="nav-item nav-item--sub"
                        [routerLink]="child.path"
                        routerLinkActive="active"
                        (click)="closeSidebar()">
                        <ion-icon [name]="child.icon"></ion-icon>
                        <span>{{ child.label }}</span>
                        @if (badgeFor(child.path) > 0) {
                          <span class="nav-badge">{{ badgeFor(child.path) }}</span>
                        }
                      </a>
                    }
                  </div>
                }
              }
            }
          }
        </nav>

        <div class="sidebar-footer">
          <div class="admin-info">
            <div class="admin-avatar">
              {{ auth.currentUser()?.nombre?.charAt(0) }}{{ auth.currentUser()?.apellido?.charAt(0) }}
            </div>
            <div>
              <p class="admin-name">{{ auth.currentUser()?.nombre }} {{ auth.currentUser()?.apellido }}</p>
              <p class="admin-rol">{{ auth.currentUser()?.rol }}</p>
            </div>
          </div>
          <button class="logout-btn" (click)="logout()">
            <ion-icon name="log-out-outline"></ion-icon>
          </button>
        </div>
      </aside>

      <!-- Main content -->
      <div class="main-area">
        <header class="topbar">
          <button class="hamburger" (click)="toggleSidebar()">
            <ion-icon name="menu-outline"></ion-icon>
          </button>
          <div class="topbar-brand">
            <img src="assets/moreka-logo.svg" alt="Moreka" class="brand-logo-sm">
          </div>
          <div class="topbar-right">
            <span class="topbar-user">{{ auth.currentUser()?.nombre }} {{ auth.currentUser()?.apellido }}</span>
          </div>
        </header>

        <main class="page-content">
          <router-outlet></router-outlet>
        </main>
      </div>

    </div>
  } @else {
    <router-outlet></router-outlet>
  }

</ion-app>
